import React from 'react';
import { FolderOpen, Brain, FileText, BookOpen, Zap } from 'lucide-react';
const features = [{
  icon: FolderOpen,
  title: '24 sesiones completas listas para usar',
  desc: 'Material organizado para 6 meses de trabajo terapéutico, adaptable a distintas edades y niveles.'
}, {
  icon: Brain,
  title: 'Protocolos clínicos organizados',
  desc: 'Intervenciones claras para aplicar con seguridad, sin improvisación constante.'
}, {
  icon: FileText,
  title: 'Hojas de trabajo profesionales',
  desc: 'Material imprimible para utilizar en sesión o entregar al paciente en segundos.'
}, {
  icon: BookOpen,
  title: 'Mini-guías de intervención',
  desc: 'Apoyo práctico para diferentes momentos del proceso terapéutico.'
}, {
  icon: Zap,
  title: 'Acceso inmediato',
  desc: 'Todo el contenido disponible en formato PDF desde el primer momento.'
}];
export function FeaturesSection() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-67">
      <div className="max-w-4xl mx-auto" data-id="element-68">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12" data-id="element-69">
          ¿Qué incluye?
        </h2>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-70">
          {features.map((feature, i) => <div key={i} className="bg-white p-6 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-shadow" data-id="element-71">
              <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mb-4 text-purple-600" data-id="element-72">
                <feature.icon className="w-6 h-6" data-id="element-73" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-74">
                {feature.title}
              </h3>
              <p className="text-gray-600 text-sm leading-relaxed" data-id="element-75">
                {feature.desc}
              </p>
            </div>)}
        </div>

        <div className="mt-12 bg-purple-50 p-8 rounded-2xl border border-purple-100" data-id="element-76">
          <h3 className="text-xl font-bold text-center text-purple-900 mb-6" data-id="element-77">
            Material listo para:
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-78">
            {['Sesiones individuales', 'Psicología clínica', 'Terapia cognitivo-conductual', 'Consulta privada', 'Organización del proceso', 'Seguimiento de pacientes'].map((item, i) => <div key={i} className="flex items-center gap-2 text-sm font-medium text-gray-700" data-id="element-79">
                <div className="w-2 h-2 bg-purple-500 rounded-full" data-id="element-80" />
                {item}
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}